// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dHrpSwVspRSg2Q {
  display: flex;
  flex-flow: row;
  flex-wrap: wrap;
}
.sUfaesnMf99M97 {
  display: flex;
  justify-content: center;
}
.DXO_qeCqUT17lh {
  flex: 1 1 auto;
  min-height: calc(100vh - 80px);
  padding-bottom: var(--ds-space-400, 32px);
  background-color: var(--ds-background-accent-gray-subtlest, #f1f2f4);
}
.gLEkLAWiLQdbqo {
  display: flex;
  justify-content: center;
  padding: var(--ds-space-400, 32px);
}
._4v9ETUv12VeEb {
  font-style: italic;
}
.XmJENSBsvwoc7j {
  flex-grow: 1;
  min-width: 320px;
  max-width: 800px;
  padding: var(--ds-space-400, 32px);
  border: 1px solid var(--ds-border, #091e4224);
  border-radius: 4px;
  background-color: var(--ds-surface, #ffffff);
}
.M5HeTNyfLwB2n_ {
  display: flex;
  align-items: center;
  justify-content: center;
}
.N9FVq5yFYDAMn9 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--ds-space-300, 24px);
  padding-bottom: var(--ds-space-200, 16px);
  border-bottom: 1px solid var(--ds-border, #091e4224);
}
.N9FVq5yFYDAMn9 .xUecM3vqN8T52z {
  margin: var(--ds-space-150, 12px) var(--ds-space-0, 0) var(--ds-space-0, 0);
}
.UUSUOU0C0Ih2T_ {
  padding-top: var(--ds-space-200, 16px);
  border-top: 1px solid var(--ds-border, #091e4224);
}
.UUSUOU0C0Ih2T_ button {
  margin-left: var(--ds-space-100, 8px);
}
.Xjlsn9bgG3zlCx {
  display: flex;
  justify-content: flex-end;
}
@media only screen and (max-width: 900px) {
  .XmJENSBsvwoc7j {
    padding: var(--ds-space-200, 16px);
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flexRowWrap": `dHrpSwVspRSg2Q`,
	"flexAndCenter": `sUfaesnMf99M97`,
	"body": `DXO_qeCqUT17lh`,
	"navigationAndContent": `gLEkLAWiLQdbqo`,
	"learnMoreSubtle": `_4v9ETUv12VeEb`,
	"content": `XmJENSBsvwoc7j`,
	"spinnerContainer": `M5HeTNyfLwB2n_`,
	"header": `N9FVq5yFYDAMn9`,
	"title": `xUecM3vqN8T52z`,
	"footer": `UUSUOU0C0Ih2T_`,
	"formFooter": `Xjlsn9bgG3zlCx`
};
export default ___CSS_LOADER_EXPORT___;
